const CaseStudiesWork = [
  {
    id: "slugging-analysis",
    title: "Multiphase Flow & Slugging Analysis",
    category: "Flow Assurance",
    summary:
      "Assessment of severe slugging and unstable multiphase flow behavior in an offshore pipeline system.",

    overview:
      "Offshore multiphase pipeline experiencing unstable flow behavior and severe slugging.",
    objective:
      "Assess flow regimes and identify causes of slugging under varying operating conditions.",

    scope: [
      "Multiphase simulation using OLGA",
      "Flow regime and transient analysis",
      "Evaluation of operating conditions",
    ],

    findings: [
      "Severe slugging observed at low flow rates",
      "Riser instability during transient operations",
    ],

    recommendations: [
      "Define stable operating envelope",
      "Optimize operating conditions to reduce slugging",
      "Evaluate slug mitigation strategies",
    ],

    value:
      "Improved understanding of flow behavior and operating limits to minimize slugging risks.",
  },

  {
    id: "water-injection-surge",
    title: "Water Injection Surge Analysis",
    category: "Flow Assurance",
    summary:
      "Transient analysis of a water injection system to evaluate surge pressure risks.",

    overview:
      "Water injection system subjected to pressure surges during pump trip events.",
    objective: "Evaluate surge pressures and assess system integrity.",

    scope: [
      "Transient simulation of pump trip scenarios",
      "Hydraulic modeling of injection network",
    ],

    findings: [
      "Surge pressures exceeding allowable limits",
      "Critical locations identified along pipeline",
    ],

    recommendations: [
      "Optimize valve closure timing",
      "Evaluate surge protection systems",
      "Define safe operating procedures",
    ],

    value:
      "Enhanced system safety through identification and mitigation of surge risks.",
  },

  {
    id: "gas-injection-study",
    title: "Gas Injection System Study",
    category: "Flow Assurance",
    summary:
      "Evaluation of gas injection system performance under steady and transient conditions.",

    overview:
      "Gas injection system experiencing pressure fluctuations and operational instability.",
    objective:
      "Assess system performance under steady-state and transient conditions.",

    scope: [
      "Compressor and pipeline modeling",
      "Transient simulations for start-up and shutdown",
    ],

    findings: [
      "Pressure fluctuations during transient operations",
      "Line packing effects impacting flow stability",
    ],

    recommendations: [
      "Optimize compressor operation strategy",
      "Implement controlled start-up and shutdown procedures",
    ],

    value:
      "Improved operational stability and system reliability during transient operations.",
  },

  {
    id: "cooldown-restart",
    title: "Thermal & Cool-Down and Restart Study",
    category: "Flow Assurance",
    summary:
      "Evaluation of pipeline cool-down behavior and restart feasibility.",

    overview:
      "Offshore pipeline requiring safe restart after shutdown conditions.",
    objective: "Evaluate cool-down behavior and restart feasibility.",

    scope: [
      "Thermal modeling and transient simulation",
      "Cool-down and restart analysis",
    ],

    findings: [
      "Rapid temperature drop leading to hydrate risk",
      "Critical restart pressure requirements identified",
    ],

    recommendations: [
      "Define maximum allowable shutdown duration",
      "Evaluate chemical injection strategy",
      "Establish safe restart procedures",
    ],

    value:
      "Reduced restart risk through defined thermal limits and operational strategies.",
  },

  {
    id: "hydrate-risk",
    title: "Hydrate Risk Assessment",
    category: "Flow Assurance",
    summary:
      "Hydrate risk evaluation and operating envelope definition for gas pipelines.",

    overview:
      "Gas pipeline operating under hydrate-prone pressure and temperature conditions.",
    objective:
      "Identify hydrate risk zones and define safe operating limits.",

    scope: [
      "Hydrate prediction using simulation tools",
      "Operating envelope evaluation",
    ],

    findings: [
      "Hydrate formation risk under specific operating conditions",
    ],

    recommendations: [
      "Define safe pressure-temperature operating envelope",
      "Optimize MEG / methanol injection strategy",
    ],

    value:
      "Improved flow assurance through proactive hydrate risk management.",
  },

  {
    id: "wax-deposition",
    title: "Wax Deposition Study",
    category: "Flow Assurance",
    summary:
      "Assessment of wax deposition risk and its impact on pipeline operability.",

    overview:
      "Oil pipeline with potential wax deposition affecting flow performance.",
    objective:
      "Assess wax deposition risk and operational impact.",

    scope: [
      "Wax appearance temperature (WAT) analysis",
      "Deposition trend evaluation",
    ],

    findings: [
      "High deposition risk under low temperature conditions",
    ],

    recommendations: [
      "Optimize pigging frequency",
      "Evaluate thermal and chemical mitigation options",
    ],

    value:
      "Reduced risk of flow restriction and improved pipeline operability.",
  },

  {
    id: "production-optimization",
    title: "Production System Optimization",
    category: "Flow Assurance",
    summary:
      "End-to-end system analysis to identify bottlenecks and improve production efficiency.",

    overview:
      "Integrated production system experiencing reduced performance and flow constraints.",
    objective:
      "Identify bottlenecks and improve overall system efficiency.",

    scope: [
      "End-to-end system modeling",
      "Sensitivity and performance analysis",
    ],

    findings: [
      "Flow constraints identified in key pipeline sections",
      "Operating limitations affecting production rates",
    ],

    recommendations: [
      "Debottleneck critical sections",
      "Optimize operating parameters",
    ],

    value:
      "Enhanced production efficiency through targeted system optimization.",
  },

  {
    id: "flare-study",
    title: "Process Simulation & Flare System Study",
    category: "Process Engineering",
    summary:
      "Validation of flare and relief system performance under blowdown conditions.",

    overview:
      "Process facility requiring validation of flare and relief system performance.",
    objective:
      "Ensure safe handling of relief and blowdown scenarios.",

    scope: [
      "Process simulation using Aspen HYSYS",
      "Flare and blowdown analysis",
    ],

    findings: [
      "Peak relief load conditions identified",
      "System limitations under extreme scenarios",
    ],

    recommendations: [
      "Validate flare system capacity",
      "Optimize blowdown and relief strategy",
    ],

    value:
      "Improved safety and compliance through validated relief system design.",
  },
];

export default CaseStudiesWork;